import React, { Component } from "react";
import "./photoGallery.css";

import MC1 from "./data/gallery/MC1.jpg";
import MC2 from "./data/gallery/MC2.jpg";
import MC3 from "./data/gallery/MC3.jpg";
import MC4 from "./data/gallery/MC4.jpg";
import MC5 from "./data/gallery/MC5.jpg";
import MC6 from "./data/gallery/MC6.jpg";
import MC7 from "./data/gallery/MC7.jpg";
import MC8 from "./data/gallery/MC8.jpg";
import MC9 from "./data/gallery/MC9.jpg";
import MC10 from "./data/gallery/MC10.jpg";
import MC11 from "./data/gallery/MC11.jpg";
import Footer from "./footer";
import Header from "./header";

const DEFAULT_PHOTOS = [
  { id: 1, frame: "1", src: MC1, ratio: "wide" },
  { id: 2, frame: "2", src: MC2, ratio: "short" },
  { id: 3, frame: "3", src: MC3, ratio: "short" },
  { id: 4, frame: "4", src: MC4, ratio: "short" },
  { id: 5, frame: "5", src: MC5, ratio: "wide" },
  { id: 6, frame: "6", src: MC6, ratio: "short" },
  { id: 7, frame: "7", src: MC7, ratio: "wide" },
  { id: 8, frame: "8", src: MC8, ratio: "short" },
  { id: 9, frame: "9", src: MC9, ratio: "short" },
  { id: 10, frame: "10", src: MC10, ratio: "short" },
  { id: 11, frame: "11", src: MC11, ratio: "short" },
];

// how far (in px) a swipe has to travel before it counts as next/prev
const SWIPE_THRESHOLD = 40;

class PhotoGallery extends Component {
  state = {
    activeIndex: null,
  };

  touchStartX = null;
  touchDeltaX = 0;

  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }

  get photos() {
    return this.props.photos || DEFAULT_PHOTOS;
  }

  handleKeyDown = (e) => {
    if (this.state.activeIndex === null) return;
    if (e.key === "Escape") this.close();
    if (e.key === "ArrowRight") this.next();
    if (e.key === "ArrowLeft") this.prev();
  };

  handleTouchStart = (e) => {
    this.touchStartX = e.touches[0].clientX;
    this.touchDeltaX = 0;
  };

  handleTouchMove = (e) => {
    if (this.touchStartX === null) return;
    this.touchDeltaX = e.touches[0].clientX - this.touchStartX;
  };

  handleTouchEnd = () => {
    if (Math.abs(this.touchDeltaX) > SWIPE_THRESHOLD) {
      if (this.touchDeltaX < 0) this.next();
      else this.prev();
    }
    this.touchStartX = null;
    this.touchDeltaX = 0;
  };

  open = (index) => this.setState({ activeIndex: index });

  close = () => this.setState({ activeIndex: null });

  next = () => {
    const total = this.photos.length;
    this.setState((prev) => ({ activeIndex: (prev.activeIndex + 1) % total }));
  };

  prev = () => {
    const total = this.photos.length;
    this.setState((prev) => ({
      activeIndex: (prev.activeIndex - 1 + total) % total,
    }));
  };

  render() {
    const { activeIndex } = this.state;
    const photos = this.photos;
    const isOpen = activeIndex !== null;
    const title = this.props.title || "Field Notes";
    const subtitle =
      this.props.subtitle ||
      "A contact sheet from the range, printed in order of exposure.";

    return (
      <div
        className="pg-root"
        style={{
          backgroundColor: "#F0F0F0",
          color: "#003968",
        }}
      >
        <div className="d-flex flex-column min-vh-100">
          <Header
            onlanguage={this.props.onlanguage}
            onChangeLanguage={this.props.onChangeLanguage}
            onEngLanguage={this.props.onEngLanguage}
            onGeoLanguage={this.props.onGeoLanguage}
          />

          <div className="pb-2 flex-grow-1">
            <div className="container-fluid pg-grid">
              {/* <div className="pg-intro">
                <p className="pg-eyebrow">Gallery</p>
                <h1 className="pg-title">{title}</h1>
                <p className="pg-subtitle">{subtitle}</p>
                <p className="pg-count">
                  {String(photos.length).padStart(2, "0")} FRAMES
                </p>
              </div> */}
              <br />
              <div className="row g-3">
                {photos.map((photo, index) => (
                  <div
                    key={photo.id}
                    className={`col-6 col-md-3 pg-col pg-col-${photo.ratio}`}
                  >
                    <button
                      className="pg-thumb"
                      onClick={() => this.open(index)}
                    >
                      <img
                        src={photo.src}
                        alt={`Frame ${photo.frame}`}
                        loading="lazy"
                        className="pg-thumb-img"
                      />
                      <div className="pg-thumb-overlay" />
                      <span className="pg-frame-tag">{photo.frame}</span>
                    </button>
                  </div>
                ))}
              </div>
            </div>

            {isOpen && (
              <div
                className="pg-lightbox"
                onClick={this.close}
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={this.handleTouchEnd}
              >
                <button
                  className="pg-btn pg-btn-close"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.close();
                  }}
                  aria-label="Close"
                >
                  &times;
                </button>

                <button
                  className="pg-btn pg-btn-prev"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.prev();
                  }}
                  aria-label="Previous photo"
                >
                  &#8249;
                </button>

                <div
                  className="pg-lightbox-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="pg-lightbox-frame">
                    <img
                      src={photos[activeIndex].src}
                      alt={`Frame ${photos[activeIndex].frame}`}
                      className="pg-lightbox-img"
                    />
                    <span className="pg-frame-tag pg-frame-tag-lightbox">
                      {photos[activeIndex].frame}
                    </span>
                  </div>
                  <div className="pg-lightbox-meta">
                    <p className="pg-lightbox-index">
                      {String(activeIndex + 1).padStart(2, "0")} /{" "}
                      {String(photos.length).padStart(2, "0")}
                    </p>
                  </div>
                </div>

                <button
                  className="pg-btn pg-btn-next"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.next();
                  }}
                  aria-label="Next photo"
                >
                  &#8250;
                </button>
              </div>
            )}
          </div>
            <br />
          <Footer
            onlanguage={this.props.onlanguage}
            onChangeLanguage={this.props.onChangeLanguage}
            onEngLanguage={this.props.onEngLanguage}
            onGeoLanguage={this.props.onGeoLanguage}
          />
        </div>
      </div>
    );
  }
}

export default PhotoGallery;